import React from 'react';
import { Image } from 'gql/autogen/Image';
import getMediaTypeDetails, { ActivityMediaType } from 'core/utils/checkImageLinkType';
import 'component/page/deprecatedDetail/DetailCard/ActivityCarousel/ActivityCarouselImage.scss';
import { selectScreenSize } from 'store/slice/screen';
import { useSelector } from 'react-redux';
import { StringFormatter } from '@agoda/react-handyman';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';
import { ActivityImage } from 'component/common/ActivityImage/ActivityImage';

interface Props {
    image: Image;
    onLoad?: Function;
    style?: React.CSSProperties;
    isMosaicEnabled?: boolean;
    imageIndex: number;
    totalImages: number;
}

const CarouselStyle: React.CSSProperties = { width: '100%', objectPosition: 'center' };

const CarouselImage: React.FC<Props> = React.memo((props) => {
    const [isLoadFinished, setIsLoadFinished] = React.useState(false);
    const [activityMediaType, setActivityMediaType] = React.useState(ActivityMediaType.Image);
    const mergedStyle = React.useMemo(() => ({ ...CarouselStyle, ...props.style }), [props.style]);
    const imageUrl = props.image.url;
    const imageDescription = props.image.description;
    const screenSize = useSelector(selectScreenSize);
    const imageIndex = props.imageIndex;
    const totalImages = props.totalImages;
    const cms = useSelector(selectCmsFromBootstrap);

    React.useEffect(() => {
        async function checkMediaType() {
            const mediaType = await getMediaTypeDetails(imageUrl);
            setActivityMediaType(mediaType);
        }
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        checkMediaType();
    }, [imageUrl]);

    if (imageUrl === undefined) {
        return null;
    }

    const onLoadFinished = () => {
        setIsLoadFinished(true);
        if (props.onLoad != null && typeof props.onLoad === 'function') {
            props.onLoad();
        }
    };

    if (activityMediaType === ActivityMediaType.Video) {
        return (
            // eslint-disable-next-line @agoda/agoda-a11y/no-non-drone-popper -- @agoda/agoda-a11y/no-non-drone-popper[d337718c-13c7-4c60-b1af-abdc64b820b9]
            <video style={CarouselStyle} src={imageUrl} title={imageDescription} controls={true} autoPlay={false}>
                <track src="" kind="captions" />
            </video>
        );
    }

    return (
        <ActivityImage
            className={`ActivityCarouselImage ${isLoadFinished ? 'ActivityCarouselImage--loaded' : ''}`}
            src={imageUrl}
            alt={StringFormatter.format(cms[321481], imageIndex, totalImages)}
            title={imageDescription}
            onLoad={onLoadFinished}
            borderRadius={props.isMosaicEnabled ? '8' : '0'}
            objectFit="cover"
            height="100%"
            minWidth={!screenSize.tabletOrDesktop && props.isMosaicEnabled ? '294px' : undefined}
            maxHeight="360px"
            style={mergedStyle}
            loading="immediate"
            responsive="original"
        />
    );
});
CarouselImage.displayName = 'CarouselImage';

export default CarouselImage;
